import { GiveAsAGift } from '@/messages/common';

import * as S from './Button4Gift.styles';

interface Button4GiftProps {
  onClick: () => void;
}

export const Button4Gift = ({ onClick }: Button4GiftProps) => {
  return (
    <S.BtnContainer onClick={onClick}>
      <S.GiftBtnContainer>{GiveAsAGift}</S.GiftBtnContainer>
    </S.BtnContainer>
  );
};
